import React from 'react';
import { Line } from 'react-chartjs-2';
import Announcement from './Announcement';
import 'chartjs-plugin-datalabels';

function IncomeChart({
  reports, title, strIncome, strCost, strExpectedCost, higher, showPartTimeCost
}) {
  const options = {

    scales: {
      yAxes: [
        {
          ticks: {
            callback(label) {
              let finalLabel = label;
              if (label >= 1000000) finalLabel = `${label / 1000000}M`;
              if (label >= 1000 && label < 1000000) finalLabel = `${label / 1000}K`;
              return finalLabel;
            },
            min: 0,
          },
          scaleLabel: {
            display: true,
            labelString: '1K = 1,000, 1M = 1000,000',
          }
        },
      ],
    },
    plugins: {
      datalabels: false
    }
  };
  var data = {
    labels: reports.length ? reports.map(yearReport => yearReport.time) : [],
    datasets: [
      {
        label: strCost,
        fill: false,
        lineTension: 0,
        backgroundColor: 'rgba(250,0,0,1)',
        borderColor: 'rgba(250,0,0,1)',
        pointBackgroundColor: '#fff',
        data: reports.length ? reports.map(yearReport => yearReport.finalCost) : [],
        pointRadius: 6,
        pointHoverRadius: 6,
      }, {
        label: strIncome,
        fill: false,
        lineTension: 0,
        backgroundColor: 'DarkSeaGreen',
        borderColor: 'DarkSeaGreen',
        pointBackgroundColor: '#fff',
        data: reports.length ? reports.map(yearReport => yearReport.income) : [],
        pointRadius: 6,
        pointHoverRadius: 6,
      }
    ],
  };
  if(showPartTimeCost)
    {
      data.datasets.push(      {
        label: '兼職成本',
        fill: false,
        lineTension: 0,
        backgroundColor: 'rgba(0,120,120,1)',
        borderColor: 'rgba(0,120,120,1)',
        data: reports.length ? reports.map(yearReport => yearReport.finalPartTimeCost) : [],
        pointRadius: 6,
        pointHoverRadius: 6,
      });
      data.datasets.push( {
        label: '正職成本',
        fill: false,
        lineTension: 0,
        backgroundColor: 'rgba(0, 0, 250, 1)',
        borderColor: 'rgba(0, 0, 250, 1)',
        pointBackgroundColor: '#fff',
        data: reports.length ? reports.map(yearReport => yearReport.finalFullTimeCost) : [],
        pointRadius: 6,
        pointHoverRadius: 6,
      });
    }
  if(strExpectedCost)
    data.datasets.push( {
      label: strExpectedCost,
      fill: false,
      lineTension: 0,
      backgroundColor: 'rgba(250, 100, 0, 1)',
      borderColor: 'rgba(250, 100, 0, 1)',
      pointBackgroundColor: '#fff',
      data: reports.length ? reports.map(yearReport => yearReport.expectCost) : [],
      pointRadius: 6,
      pointHoverRadius: 6,
    });
  if (reports && reports.length && reports[0] === 0) {
    return (
      <div className="loading__overlay">
        <div className="loading__content">
          <div className="spinner" />
        </div>
      </div>
    );
  }

  if (reports && reports.length === 0) {
    return <Announcement title={title} content="目前還沒有資料" />;
  }

  return (
    <div style={{ overflowX: 'auto', marginBottom: '20px', padding: '2px' }}>
      <div style={{ paddingLeft:'80px',paddingRight:'130px', position: 'relative', minWidth: '800px', width: '100%', border: '3px solid #dfdfdf', borderRadius: '5px', textAlign: 'center' }}>
        <h2>{title}</h2>
        <Line data={data} options={options}  height={higher?100: 50}/>
      </div>
    </div>
  );
}

export default IncomeChart;
